<template>
  <div>
      <p>Hello Nutan {{this.LineID}}</p>
  </div>
</template>

<script>
/**
 * This component is used to CRM url redirect to given navigation
 * Intentionally created component to add further functionality  beofre CRM redirect
 */
import postData from '../../services/postData';
import commonService from '../../services/common';
// import axios from '../../axios-config';
/* eslint-disable */
export default {
  props: ['Area','User','LineID','EntityID','A','sessionid'],
  created() {
     const epicImportQueryData = {
        Area: this.Area, 
        User: this.User, 
        LineID: this.LineID, 
        EntityID: this.EntityID,
        A: this.A,
        sessionid:this.sessionid
      };
      const appliedepicurl='/importappliedepic';
      const requestParams = {
        url: appliedepicurl,
        data: epicImportQueryData,
      };
    postData.getEpicImportSession(requestParams).then((response) => {
      if (response.data.Navigate) {
        const responseData=response.data.Navigate;
        const sessId = responseData.slice(responseData.indexOf('{'), responseData.indexOf('}') + 1);
        this.$store.dispatch('setCurrentNav',responseData);
        const routeName = commonService.getRouteName(responseData);
        this.$store.dispatch('setSessionQuote', { SessionId: sessId });
        this.$router.replace(routeName);
      }
    }).catch((error) => {
      console.log('error', error);
    });




//     // if (this.LineID && this.LineID !== '') {
//           const Navigate1="/pages/namedinsured/{8496b53b-9007-4681-b1ae-c4f35b8d100f}"
//           const sessId = '8496b53b-9007-4681-b1ae-c4f35b8d100f';
//          return axios.get(Navigate1)
//          .then((response) => { // TODO: Refactor: Don't use this mixin method
//           if (response.data.Navigate) {
//             this.$store.dispatch('setCurrentNav', response.data.Navigate);
//             // set session id in store
//             this.$store.dispatch('setSessionQuoteCRM', { SessionId: sessId });
//             // identify route and redirect
//             console.log("EpicImport",this.LineID );
//             const routeName = commonService.getRouteName('/pages/Drivers/{8496b53b-9007-4681-b1ae-c4f35b8d100f}');
//             this.$router.replace(routeName);
//           }
//         });
//     }
},
};
</script>




// WEBPACK FOOTER //
// src/components/interview/EpicImport.vue?0eaffd1a